import { PersonnelData } from "../types/PersonnelData";
import { StagingTitelineAppPersonnel } from "../types/StagingTitelineAppPersonnel";
import { getApiUrl } from '../config/api';

export const fetchPersonnelByPid = async (pid: number, aid: number = -1): Promise<PersonnelData[]> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelinePersonnel/GetPersonnelByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            console.log("Failed to fetch personnel data by pid:", pid, "state:", response.status, response.statusText);
            return [];
        }

        let backendData: StagingTitelineAppPersonnel[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((person) => person.DataSource === aid.toString());
        }

        const transformedData: PersonnelData[] = backendData.map((person) => ({
            key: person.PerId,
            per_id: person.PerId,
            pid: person.Pid,
            position: person.Position,
            name: person.Name,
            time_start: person.TimeStart,
            time_finish: person.TimeFinish,
            total_hours: person.Hours,
            travel_day: person.TravelDay,
            sick_day: person.SickDay,
        }));

        return transformedData;
    } catch (error) {
        console.error("Error in fetchPersonnelByPid API call:", error);
        return [];
    }
};

export const addPersonnelRow = async (personnelRow: PersonnelData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelinePersonnel/AddPersonnel');

    const cloudPayload = [
        {
            Pid: personnelRow.pid ?? -1,
            Position: personnelRow.position,
            Name: personnelRow.name,
            Hours: personnelRow.total_hours,
            TimeStart: personnelRow.time_start,
            TimeFinish: personnelRow.time_finish,
            TravelDay: personnelRow.travel_day,
            SickDay: personnelRow.sick_day,
            DataSource: aid,
        },
    ];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log("Personnel row added to cloud successfully.");
            return true;
        } else {
            console.error(
                "Failed to add personnel row to cloud:",
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in addPersonnelRow API call:", error);
        return false;
    }
};

export const updatePersonnelRow = async (perId: number, updatedRow: PersonnelData) => {
    const apiUrl = getApiUrl(`/api/TitelinePersonnel/UpdatePersonnelByPid/${perId}`);

    const cloudPayload = {
        Position: updatedRow.position,
        Name: updatedRow.name,
        Hours: updatedRow.total_hours,
        TimeStart: updatedRow.time_start,
        TimeFinish: updatedRow.time_finish,
        TravelDay: updatedRow.travel_day,
        SickDay: updatedRow.sick_day,
    };

    console.log(`cloudPayload`,cloudPayload);

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log(`Personnel row with PerId ${perId} updated successfully.`);
            return true;
        } else {
            console.error(
                `Failed to update personnel row with PerId ${perId}:`,
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in updatePersonnelRow API call:", error);
        return false;
    }
};

export const deletePersonnelByPid = async (pid: number) => {
    const apiUrl = getApiUrl(`/api/TitelinePersonnel/DeletePersonnelByPid/${pid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            const responseData = await response.json();
            console.log("DeletePersonnelByPid API response:", responseData);
            return true;
        } else {
            console.error("Failed to delete personnel row from the cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in deletePersonnelByPid API call:", error);
        return false;
    }
};

export const fetchTotalPersonnelNo = async (pid?: number, aid: number = 0): Promise<number> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelinePersonnel/GetTotalPersonnelNumber/${validPid}/${aid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error(`Failed to fetch total personnel number. Status: ${response.status} - ${response.statusText}. Error: ${errorText}`);
            return 0;
        }

        const data = await response.json();

        const personnelNo = data?.total_personnel ?? 0;

        return personnelNo;
    } catch (error) {
        console.error("fetchTotalPersonnelNo error:", error);
        return 0;
    }
};
